import { ICellRendererParams } from '@ag-grid-community/core';
import { Component } from '@angular/core';
import { Constants } from '@app/core/constants/constants';
import { ToasterService } from '@app/core/services/toaster.service';

@Component({
  selector: 'app-copy-note-cell-renderer',
  templateUrl: './copy-note-cell-renderer.component.html',
  styles: [
  ]
})
export class CopyNoteCellRendererComponent {

  note = '';

  constructor(private readonly toastService: ToasterService) {
  }

  agInit(params: ICellRendererParams): void {
    this.note = params.value ?? '';
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  copyNote(event: Event): void {
    event.stopPropagation();
    this.writeToClipboard()
      .then(() => this.toastService.showSuccessMessage(Constants.noteCopiedMessage))
      .catch(() => this.toastService.showErrorMessage(Constants.noteCopyFailed));
  }

  private writeToClipboard(): Promise<void> {
    if (navigator.clipboard?.writeText) {
      return navigator.clipboard.writeText(this.note);
    }
    return this.copyUsingTextArea();
  }

  // Fallback for browsers that block the async clipboard API outside a secure context.
  private copyUsingTextArea(): Promise<void> {
    const textArea = document.createElement('textarea');
    textArea.value = this.note;
    textArea.style.position = 'fixed';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.select();
    try {
      return document.execCommand('copy') ? Promise.resolve() : Promise.reject();
    } finally {
      document.body.removeChild(textArea);
    }
  }
}
